import React, { useState, useEffect, useRef, useMemo } from "react";
import clsx from "clsx";
import { useMediaQuery } from "react-responsive";
import { motion } from "framer-motion";
import { imgPremium, imgAppStore, imgGooglePlay } from "../../assets/images";
import styles from "./styles.module.scss";
import { mediaQueries } from "../../constant";

export default function PremiumApps() {
  const refHeading = useRef();
  const refContent = useRef();
  const refDownload = useRef();
  const [elTopHeading, setElTopHeading] = useState(0);
  const [elTopContent, setElTopContent] = useState(0);
  const [elTopDownload, setElTopDownload] = useState(0);
  const [showElHeading, setShowElHeading] = useState(false);
  const [showElContent, setShowElContent] = useState(false);
  const [showElDownload, setShowElDownload] = useState(false);
  const [startingPoint, setStartingPoint] = useState(0);

  const isBiggerScreen = useMediaQuery({
    query: `(min-device-width: ${mediaQueries?.tablet}px)`,
  });
  const variantContainer = {
    offScreen: { opacity: 1 },
    onScreen: {
      opacity: 1,
      transition: {
        // when: "beforeChildren",
        // staggerChildren: 0.3,
      },
    },
  };
  const variantContentContainer = {
    offScreen: { opacity: 0 },
    onScreen: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.3,
        // delay: 0.25,
      },
    },
  };
  const variantContent = {
    offScreen: { x: 50, opacity: 0 },
    onScreen: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 1.5,
      },
    },
  };
  const variantImg = {
    offScreen: { x: -50, opacity: 0 },
    onScreen: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 1.5,
      },
    },
  };
  const variantDownload = {
    offScreen: { y: 50, opacity: 0 },
    onScreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 1.5,
        delay: 1,
      },
    },
  };

  const checkScrollCondition = () => {
    if (
      window.pageYOffset > 0 &&
      elTopHeading > 0 &&
      window.pageYOffset + startingPoint > elTopHeading
    ) {
      setShowElHeading(true);
    } else {
      setShowElHeading(false);
    }
    if (
      window.pageYOffset > 0 &&
      elTopContent > 0 &&
      window.pageYOffset + startingPoint > elTopContent
    ) {
      setShowElContent(true);
    } else {
      setShowElContent(false);
    }
    if (
      window.pageYOffset > 0 &&
      elTopDownload > 0 &&
      window.pageYOffset + startingPoint > elTopDownload
    ) {
      setShowElDownload(true);
    } else {
      setShowElDownload(false);
    }
  };

  useEffect(() => {
    const setValues = () => {
      setStartingPoint(window.innerHeight * 0.9);
      if (refHeading.current) setElTopHeading(refHeading.current.offsetTop);
      if (refContent.current) setElTopContent(refContent.current.offsetTop);
      if (refDownload.current) setElTopDownload(refDownload.current.offsetTop);
    };

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, [refHeading, refContent]);

  useEffect(() => {
    document.addEventListener("scroll", checkScrollCondition, {
      passive: true,
    });

    return () => {
      document.removeEventListener("scroll", checkScrollCondition, {
        passive: true,
      });
    };
  });

  return (
    <div className={clsx("mt-12 lg:mt-32", styles.premiumApps)}>
      <motion.div
        ref={refHeading}
        variants={variantContainer}
        initial="offScreen"
        whileInView={showElHeading ? "onScreen" : "offScreen"}
        // viewport={{ once: true }}
        className={clsx(
          "pb-12 lg:py-32 flex flex-wrap items-center overflow-hidden",
          styles.container
        )}
      >
        <div className="w-1/2">
          <motion.div variants={variantImg} className="lg:w-2/3 mx-auto">
            <img src={imgPremium} alt="img-premium_apps" />
          </motion.div>
        </div>
        <div className="w-1/2 pl-4 lg:px-8">
          <motion.h3
            variants={variantContent}
            className="text-4xl md:text-6xl lg:text-8xl headline-remo"
          >
            OXONE <span className="block" ref={refContent} />{" "}
            <span className={styles.textYellow}>PREMIUM</span>{" "}
            <span className="block" /> APPS
          </motion.h3>
          <motion.div
            variants={variantContentContainer}
            initial="offScreen"
            whileInView={
              showElHeading && showElContent ? "onScreen" : "offScreen"
            }
            className="mt-2 lg:mt-8 "
          >
            <motion.h5
              variants={variantContent}
              className="font-bold text-xl md:text-2xl lg:text-3xl"
            >
              Unduh aplikasi <span className={styles.textYellow}>OPA</span> dan
              dapatkan segala manfaatnya
            </motion.h5>
            <motion.p
              variants={variantContent}
              className="mt-2 lg:mt-8 lg:text-xl"
            >
              Dapatkan semua kemudahan belanja produk terbaik Oxone dengan
              mudah, nikmati penawaran menarik dari Oxone dan dapatkan komisi
              setiap kali kamu berbelanja.
            </motion.p>
            {isBiggerScreen && (
              <motion.div
                variants={variantContent}
                className="flex mt-2 lg:mt-8"
              >
                <div className="w-1/4">
                  <img src={imgAppStore} alt="img-download_on_app_store" />
                </div>
                <div className="ml-4 w-1/4">
                  <img src={imgGooglePlay} alt="img-download_on_google_play" />
                </div>
              </motion.div>
            )}
          </motion.div>
        </div>
        {!isBiggerScreen && (
          <motion.div
            ref={refDownload}
            variants={variantDownload}
            initial="offScreen"
            whileInView={showElDownload ? "onScreen" : "offScreen"}
            className="flex mt-8 mx-auto w-4/5"
          >
            <div className="w-1/2">
              <img src={imgAppStore} alt="img-download_on_app_store" />
            </div>
            <div className="ml-4 w-1/2">
              <img src={imgGooglePlay} alt="img-download_on_google_play" />
            </div>
          </motion.div>
        )}
      </motion.div>
    </div>
  );
}
